module.exports = __webpack_public_path__ + "img/GoogleMaps.fd79a17c.png";